const DEFAULT_CONFIG = {
  app: {
    mode: "local",
    workspaceName: "Franchise Portal",
    allowLocalFallback: true,
  },
  auth: {
    provider: "none",
    requireLogin: false,
    inviteOnly: true,
    allowedEmailDomains: [],
    redirectTo: "",
  },
  supabase: {
    url: "",
    anonKey: "",
  },
  asana: {
    pat: "",
    workspaceGid: "",
  },
};

function normalizeDomainList(values) {
  return (Array.isArray(values) ? values : [])
    .map((value) => String(value || "").trim().toLowerCase())
    .filter(Boolean);
}

export function getAppConfig() {
  const runtimeConfig = globalThis.FRANCHISE_PORTAL_CONFIG || {};
  const config = {
    app: {
      ...DEFAULT_CONFIG.app,
      ...(runtimeConfig.app || {}),
    },
    auth: {
      ...DEFAULT_CONFIG.auth,
      ...(runtimeConfig.auth || {}),
    },
    supabase: {
      ...DEFAULT_CONFIG.supabase,
      ...(runtimeConfig.supabase || {}),
    },
    asana: {
      ...DEFAULT_CONFIG.asana,
      ...(runtimeConfig.asana || {}),
    },
  };

  config.app.mode = String(config.app.mode || "local").trim().toLowerCase() === "supabase"
    ? "supabase"
    : "local";
  config.app.workspaceName = String(config.app.workspaceName || DEFAULT_CONFIG.app.workspaceName).trim()
    || DEFAULT_CONFIG.app.workspaceName;
  // Hard-gate the dev-mode admin fallback to localhost only — even if a deployed
  // cloud-config.js sets allowLocalFallback: true, prod hosts cannot enable it.
  const isLocalHost =
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
  config.app.allowLocalFallback = Boolean(config.app.allowLocalFallback) && isLocalHost;

  config.auth.provider = String(config.auth.provider || "none").trim().toLowerCase() === "supabase"
    ? "supabase"
    : "none";
  config.auth.requireLogin = Boolean(config.auth.requireLogin);
  config.auth.inviteOnly = Boolean(config.auth.inviteOnly);
  config.auth.allowedEmailDomains = normalizeDomainList(config.auth.allowedEmailDomains);
  config.auth.redirectTo = String(config.auth.redirectTo || "").trim();

  config.supabase.url = String(config.supabase.url || "").trim();
  config.supabase.anonKey = String(config.supabase.anonKey || "").trim();

  config.asana.pat = String(config.asana.pat || "").trim();
  config.asana.workspaceGid = String(config.asana.workspaceGid || "").trim();

  // External app configs (Social Calendar, Game Admin, etc.)
  config.externalApps = runtimeConfig.externalApps || {};

  return config;
}

export function getExternalAppConfig(appId, config = getAppConfig()) {
  return config.externalApps?.[appId] || {};
}

export function isSupabaseMode(config = getAppConfig()) {
  return config.app.mode === "supabase" && config.auth.provider === "supabase";
}

export function isSupabaseConfigured(config = getAppConfig()) {
  return isSupabaseMode(config) && Boolean(config.supabase.url && config.supabase.anonKey);
}

export function getAllowedEmailDomains(config = getAppConfig()) {
  return config.auth.allowedEmailDomains || [];
}

export function getAsanaConfig(config = getAppConfig()) {
  return config.asana || {};
}

export function getAuthRedirectUrl(config = getAppConfig()) {
  if (config.auth.redirectTo) {
    return config.auth.redirectTo;
  }
  if (typeof window === "undefined") {
    return "";
  }
  return window.location.origin;
}
